// extracted by mini-css-extract-plugin
export default {"container":"aj-z","blurb":"bj-z","links":"cj-z"};